<mj-record-form-container [Record]="record" [FormComponent]="this"
    (Navigate)="OnFormNavigate($event)"
    (DeleteRequested)="OnDeleteRequested()"
    (FavoriteToggled)="OnFavoriteToggled()"
    (HistoryRequested)="OnHistoryRequested()"
    (ListManagementRequested)="OnListManagementRequested()">

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="before-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         FIELD PANELS
         ======================================== -->
    <!-- Details Section -->
    <mj-collapsible-panel
        SectionKey="details"
        SectionName="Details"
        Icon="fa fa-align-left"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="CompetitionID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="ProductID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="CategoryID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="EntryNumber"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="SubmittedDate"
            Type="datepicker"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Status"
            Type="select"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Score"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Ranking"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="AwardLevel"
            Type="select"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="JudgingNotes"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="FeedbackProvided"
            Type="checkbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="EntryFee"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="PaymentStatus"
            Type="select"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_CreatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_UpdatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         RELATED ENTITY PANELS
         ======================================== -->

    <!-- Product Awards Section -->
    <mj-collapsible-panel
        SectionKey="productAwards"
        SectionName="Product Awards"
        Icon="fa fa-table"
        Variant="related-entity"
        [Form]="this"
        [FormContext]="formContext"
        [BadgeCount]="GetSectionRowCount('productAwards')"
        [DefaultExpanded]="false">
        @if (record.IsSaved) {
        <div>
            <mj-explorer-entity-data-grid
                [Params]="BuildRelationshipViewParamsByEntityName('Product Awards','CompetitionEntryID')"
                [NewRecordValues]="NewRecordValues('Product Awards','CompetitionEntryID')"
                [AllowLoad]="IsSectionExpanded('productAwards')"
                [ShowToolbar]="true"
                (Navigate)="OnFormNavigate($event)"
                (AfterDataLoad)="SetSectionRowCount('productAwards', $event.totalRowCount)"
                >
            </mj-explorer-entity-data-grid>
        </div>
        }
    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-related" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>
</mj-record-form-container>
        